// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

    production: false,
    url: 'https://finance.isocptest.com',

    // url: 'localhost:4200',

    server: 'https://rnavapi-test.isocptest.com/rnav/rnavapi',

    // server: 'http://localhost:3000/rnavapi',

    // server: 'https://blnyrtbhrk.execute-api.us-east-1.amazonaws.com/latest',

    okta_issuer: 'https://sso.int.verisk.com/oauth2/aus16fwz1gh8z7Ivh0h8',

    okta_client_id: '0oa2hqrdg63uL5Sq80h8',

    okta_redirect_uri: 'https://finance.isocptest.com/login/callback',

    // okta_redirect_uri: 'http://localhost:4200/login/callback'

    apiUrl:'https://api-internal-us.test.casualty.claims.verisk.com/findenav/findenavapi'
      // apiUrl:'http://localhost:7099/findenav/findenavapi'
    ,

    launch_darkly_sdk_key: '68da8476e72fff09a54ba423'

  };
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
